import { FormattedMessage } from 'react-intl';
import chatTokenActions from 'src/store/actions/chatToken';
import messagesActions from 'src/store/actions/message';
import { handleRemoveSources } from 'src/store/actions/sources';
import { useAppDispatch } from 'universal-scripts';

import './NewChatButton.sass';

const NewChatButton = ({ disabled, callback }: { disabled: boolean; callback?: () => void }) => {
	const dispatch = useAppDispatch();

	const handleRemoveMessages = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		dispatch(messagesActions.removeAllMessages());
		dispatch(chatTokenActions.removeChatToken());
		dispatch(handleRemoveSources());
		if (callback) {
			callback();
		}
	};

	return (
		<button disabled={disabled} className="new-chat-button" onClick={handleRemoveMessages}>
			<span className="icon icon-plus" />
			<span>
				<FormattedMessage id="new-chat" />
			</span>
		</button>
	);
};

export default NewChatButton;
